import React from 'react';
import { store } from './store';
import { theme } from './theme';
import { Provider } from 'react-redux';
import { ThemeProvider } from '@mui/material/styles';
import { BrowserRouter as Router } from 'react-router-dom';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { ruRU } from '@mui/x-date-pickers/locales';
import dayjs from 'dayjs';
import 'dayjs/locale/ru';
import { NotificationProvider } from './contexts/NotificationContext';
import RootRoutes from './routes/RootRoutes';
import CssBaseline from '@mui/material/CssBaseline';
import Index from './components/NotificationInitializer';
import InternetStatus from './components/InternetStatus';

// Устанавливаем русскую локаль для dayjs
dayjs.locale('ru');

function App() {
  return (
    <Provider store={store}>
      <LocalizationProvider
        dateAdapter={AdapterDayjs}
        adapterLocale="ru"
        localeText={ruRU.components.MuiLocalizationProvider.defaultProps.localeText}
      >
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <NotificationProvider>
            <Index>
              <InternetStatus />
              <Router>
                <RootRoutes />
              </Router>
            </Index>
          </NotificationProvider>
        </ThemeProvider>
      </LocalizationProvider>
    </Provider>
  );
}

export default App;
